import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bfc65c16&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc65c16')) {
      api.createRecord('bfc65c16', component.options)
    } else {
      api.reload('bfc65c16', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bfc65c16&", function () {
      api.rerender('bfc65c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/IncreaseNumber.vue"
export default component.exports